var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7496 0.286771L12.8338 1.37095C13.218 1.75513 13.2152 2.3813 12.8311 2.76548L7.40059 8.19595C7.35958 8.2356 7.31309 8.26704 7.26114 8.28892L4.04141 9.65201C3.85958 9.72857 3.67637 9.67525 3.56016 9.55767C3.44395 9.44009 3.39063 9.25826 3.46719 9.07779L4.83165 5.85943C4.85352 5.80747 4.88497 5.75962 4.92461 5.71997L10.3551 0.289506C10.7393 -0.0946741 11.3654 -0.0974085 11.7496 0.286771ZM4.9 8.2192L6.77852 7.42349L10.5902 3.61177L9.50743 2.52896L5.69571 6.34068L4.9 8.2192ZM12.1365 2.06548L11.2861 2.91587L10.2033 1.83306L11.0537 0.982666L12.1365 2.06548Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3906 7.38281C10.3906 7.11074 10.6107 6.89062 10.8828 6.89062C11.1549 6.89062 11.375 7.11074 11.375 7.38281C11.375 7.40195 11.3736 7.41973 11.3723 7.4375H11.375V12.1406C11.375 12.6848 10.9348 13.125 10.3906 13.125H0.984375C0.440234 13.125 0 12.6848 0 12.1406V2.73438C0 2.19023 0.440234 1.75 0.984375 1.75H6.125C6.39707 1.75 6.61719 1.97012 6.61719 2.24219C6.61719 2.51426 6.39707 2.73438 6.125 2.73438H0.984375V12.1406H10.3906V7.4375H10.3934C10.392 7.41973 10.3906 7.40195 10.3906 7.38281Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsIcon);
export default __webpack_public_path__ + "static/media/forms-icon.9bedc024.svg";
export { ForwardRef as ReactComponent };